import { REFRESH_TOKEN } from '../common/constants/localStorage';
import { useAxios } from './axiosService';
import { getToken } from './tokenService';

export const useAuthService = () => {
    const { axios } = useAxios();

    const signInEmailPassword = async (credentials, recaptchaToken) => {
        return await axios.post('/auth-consumers/sign-in', { credentials, recaptchaToken });
    };

    const signUpEmailPassword = async (credentials, recaptchaToken) => {
        return await axios.post('/auth-consumers/sign-up', { credentials, recaptchaToken });
    };

    // marketingConsent is passed for sign-up only; sign-in never sends it, so the API never changes consent there
    const googleAuth = async (path, code, language, marketingConsent) => {
        const body = marketingConsent === undefined ? { code, language } : { code, language, marketingConsent };

        return await axios.post(`/auth-consumers/google/${path}`, body);
    };

    const facebookAuth = async (path, code) => {
        return await axios.post(`/auth-consumers/facebook/${path}`, { code });
    };

    const getGeneratedQr = async () => {
        return await axios.get('/auth-consumers-2fa/generate-qr');
    };

    const enableTwoFactorAuth = async code => {
        return await axios.post('/auth-consumers-2fa/enable-two-factor-auth', { code });
    };

    const disableTwoFactorAuth = async code => {
        return await axios.post('/auth-consumers-2fa/disable-two-factor-auth', { code });
    };

    const twoFactorAuth = async code => {
        return await axios.post('/auth-consumers-2fa/authenticate', { code });
    };

    const changeTeam = async teamId => {
        return await axios.post(`/auth-consumers/change-team`, { teamId });
    };

    const validateInvitationToken = async token => {
        return await axios.post(`/auth-consumers/validate-invitation-token`, {
            token: token,
        });
    };

    const validateRestoreToken = async token => {
        return await axios.post(`/auth-consumers/validate-restore-token`, {
            token: token,
        });
    };

    const finishInvitation = async data => {
        return await axios.post(`/auth-consumers/finish-invitation`, data);
    };

    const forgotPassword = async email => {
        return await axios.post(`/auth-consumers/forgot-password`, {
            email: email,
        });
    };

    const changePassword = async credentials => {
        return await axios.post(`/auth-consumers/change-password`, credentials);
    };

    const decryptPreviewLink = async hash => {
        return await axios.post(`/demo/preview`, { hash });
    };

    const verifyEmail = async email => {
        return await axios.post(`/auth-consumers/verify-email`, { email });
    };

    const verifyOtp = async otpCode => {
        return await axios.post(`/auth-consumers/verify-otp`, {
            otpCode,
        });
    };

    const logout = async () => {
        return await axios.post('/auth-consumers/logout', { refreshToken: getToken(REFRESH_TOKEN) });
    };

    return {
        signInEmailPassword,
        signUpEmailPassword,
        googleAuth,
        facebookAuth,
        getGeneratedQr,
        enableTwoFactorAuth,
        disableTwoFactorAuth,
        twoFactorAuth,
        changeTeam,
        finishInvitation,
        validateInvitationToken,
        validateRestoreToken,
        forgotPassword,
        decryptPreviewLink,
        changePassword,
        verifyEmail,
        verifyOtp,
        logout,
    };
};
